import { db } from "@/firebaseConfig";

const categoriesCollection = db.collection("categories");

const saveCategory = async data => {
  categoriesCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("Category successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateCategory = async (id, data) => {
  categoriesCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Category successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteCategory = async id => {
  categoriesCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Category successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getCategoryById = async id => {
  return categoriesCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  categoriesCollection,
  saveCategory,
  updateCategory,
  deleteCategory,
  getCategoryById
};
